import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedVendor: null,
};

const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {
    setSelectedVendor: (state, action) => {
      state.selectedVendor = action.payload;
    },
    clearSelectedVendor: (state) => {
      state.selectedVendor = null;
    },
  },
});

export const { setSelectedVendor, clearSelectedVendor } = vendorSlice.actions;
export default vendorSlice.reducer;
